<template>
  <div id="app">
    <div :class="getMainContentClass">
      <div id="app-content" :class="getPrintRequestAppContentClass">
        <div id="main-page">
          <div class="container" style="padding-bottom: 1em;" v-show="showHeader">
            <div class="columns is-mobile container is-centered" v-if="!isPrintRequest">
              <div class="column">
                <img :src="logo" class="is-pulled-left" alt="logo">
              </div>
              <div class="column" v-if="showTitle">
                <div class="card is-pulled-right has-background-danger right-title" style="padding-top: 10px;">
                  <div class="card-content" style="text-align: centre !important; line-height: 28px !important; vertical-align: centre;">
                    <span class="credit-title has-text-white" :title="titleLineOne" style="padding-bottom: 0px !important; margin-bottom: 0px !important;">
                      {{ titleLineOne }}
                    </span>
                    <br />
                    <span class="credit-subtitle has-text-white" :title="titleLineTwo" style="padding-bottom: 0px !important; margin-top: 0px !important;">
                      {{ titleLineTwo }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <router-view
            @show-footer="footer"
            @set-title-one="setHeaderOne"
            @set-title-two="setHeaderTwo"
            @set-logo="setLogo"
            @show-title="title"
            @show-header="header"/>
        </div>
      </div>
    </div>
    <footer class="footer" v-if="showFooter">
      <div class="content has-text-centered">
        <p class="footer-info">
          &copy; Experience Auto Group 2023
        </p>
      </div>
    </footer>
    <portal-target name="global-modal-portal" slim></portal-target>
  </div>
</template>

<script>

export default {
  mounted: function () {
  },
  data () {
    return {
      routeName: '',
      showFooter: true,
      titleLineOne: '',
      titleLineTwo: '',
      logo: require('@/assets/eag_logo.png'),
      showTitle: true,
      showHeader: true
    }
  },
  computed: {
    getMainContentClass: function () {
      return this.showFooter ? 'main-content' : ''
    },
    getPrintRequestAppContentClass: function () {
      return !this.showFooter ? 'app-content-print-request' : ''
    },
    isPrintRequest: function () {
      return this.$route.name === 'PrintRequest'
    }
  },
  components: {
  },
  watch: {
  },
  methods: {
    footer (newValue) {
      this.showFooter = newValue
    },
    setHeaderOne (newValue) {
      this.titleLineOne = newValue
    },
    setHeaderTwo (newValue) {
      this.titleLineTwo = newValue
    },
    setLogo (newValue) {
      this.logo = newValue
    },
    title (newValue) {
      this.showTitle = newValue
    },
    header (newValue) {
      this.showHeader = newValue
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.app-content-print-request {
  height: calc(100vh - 1px) !important;
  margin-top: 0px !important;
}

//The default screen size styles. This is important to set the default styles for the app.
.title {
    font-size: 2.3rem !important;
}
.notification {
  font-size: 1.3rem !important;
}
.credit-app {
  font-size: 1.7rem !important;
  border-radius: 4px !important;
  padding: 1.25rem 1rem 1.25rem 1rem !important;
  position: relative !important;
  margin-bottom: 1.5rem !important;
}
.credit-app.is-success {
  background-color: #23d160;
  color: white;
}
.credit-title {
  font-size: 3rem !important;
}
.credit-subtitle {
  font-size: 2.5rem !important;
}
.control-label {
  font-size: 1rem !important;
}
.form-info {
  font-size: 1rem !important;
}

@media screen and (max-width: 1920px) {
  .title {
    font-size: 2.3rem !important;
  }
  .notification {
    font-size: 1.3rem !important;
  }
  .credit-app {
    font-size: 1.7rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 3rem !important;
  }
  .credit-subtitle {
    font-size: 2.5rem !important;
  }
  .control-label {
    font-size: 1rem !important;
  }
  .form-info {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 1280px) {
  .title {
    font-size: 1.8rem !important;
  }
  .notification {
    font-size: 1.2rem !important;
  }
  .credit-app {
    font-size: 1.4rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 2.5rem !important;
  }
  .credit-subtitle {
    font-size: 2rem !important;
  }
  .control-label {
    font-size: 1rem !important;
  }
  .form-info {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 1024px) {
  .title {
    font-size: 1.8rem !important;
  }
  .notification {
    font-size: 1.2rem !important;
  }
  .credit-app {
    font-size: 1.4rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 2.2rem !important;
  }
  .credit-subtitle {
    font-size: 2rem !important;
  }
  .control-label {
    font-size: 1rem !important;
  }
  .form-info {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 800px) {
  .title {
    font-size: 1.8rem !important;
  }
  .notification {
    font-size: 1.2rem !important;
  }
  .credit-app {
    font-size: 1.2rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 1.8rem !important;
  }
  .credit-subtitle {
    font-size: 1.6rem !important;
  }
  .control-label {
    font-size: 1rem !important;
  }
  .form-info {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 700px) {
  .title {
    font-size: 1.8rem !important;
  }
  .notification {
    font-size: 1.2rem !important;
  }
  .credit-app {
    font-size: 1.2rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 1.6rem !important;
  }
  .credit-subtitle {
    font-size: 1.5rem !important;
  }
  .control-label {
    font-size: 1rem !important;
  }
  .form-info {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 600px) {
  .title {
    font-size: 1.8rem !important;
  }
  .notification {
    font-size: 1.2rem !important;
  }
  .credit-app {
    font-size: 1.2rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 1.4rem !important;
  }
  .credit-subtitle {
    font-size: 1.3rem !important;
  }
  .control-label {
    font-size: 1rem !important;
  }
  .form-info {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 540px) {
  .title {
    font-size: 1.3rem !important;
  }
  .notification {
    font-size: 1rem !important;
  }
  .credit-app {
    font-size: 1rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 1.2rem !important;
  }
  .credit-subtitle {
    font-size: 1.1rem !important;
  }
  .control-label {
    font-size: 1rem !important;
  }
  .form-info {
    font-size: 1rem !important;
  }
}
@media screen and (max-width: 500px) {
  .title {
    font-size: 1.3rem !important;
  }
  .notification {
    font-size: 0.8rem !important;
  }
  .credit-app {
    font-size: 0.7rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 0.8rem !important;
  }
  .credit-subtitle {
    font-size: 0.7rem !important;
  }
  .control-label {
    font-size: 0.8rem !important;
  }
  .form-info {
    font-size: 0.8rem !important;
  }
}

@media screen and (max-width: 360px) {
  .title {
    font-size: 1.2rem !important;
  }
  .notification {
    font-size: 0.6rem !important;
  }
  .credit-app {
    font-size: 0.6rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 0.6rem !important;
  }
  .credit-subtitle {
    font-size: 0.5rem !important;
  }
  .control-label {
    font-size: 0.6rem !important;
  }
  .form-info {
    font-size: 0.6rem !important;
  }
}
@media screen and (max-width: 280px) {
  .title {
    font-size: 1rem !important;
  }
  .notification {
    font-size: 0.4rem !important;
  }
  .credit-app {
    font-size: 0.5rem !important;
    border-radius: 4px !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
    position: relative !important;
    margin-bottom: 1.5rem !important;
  }
  .credit-app.is-success {
    background-color: #23d160;
    color: white;
  }
  .credit-title {
    font-size: 0.4rem !important;
  }
  .credit-subtitle {
    font-size: 0.4rem !important;
  }
  .control-label {
    font-size: 0.5rem !important;
  }
  .form-info {
    font-size: 0.5rem !important;
  }
}
</style>
